import { Grid, Paper, Typography } from '@mui/material';

import { LIGHT_GRAY_BACKGROUND_FOR_CONTAINERS } from '../../constants/colors';
import { Children, Component, ReturnComponent, SxStyle } from '../../utils/reactTypes';
import { If } from '../utils/conditionalComponents';

export const Outline = ({
    title,
    headerButton,
    children,
    padding = 3,
    my,
    sx = {},
    enabled = true,
    variant = 'outlined',
}: {
    title?: Component | string | undefined;
    headerButton?: Component;
    children: Children;
    padding?: number;
    my?: number;
    sx?: SxStyle;
    enabled?: boolean;
    variant?: 'outlined' | 'elevation';
}): ReturnComponent => {
    return (
        <Paper
            variant={variant}
            sx={{ padding, my, ...sx }}
            style={{ backgroundColor: enabled ? '#FFFFFF' : LIGHT_GRAY_BACKGROUND_FOR_CONTAINERS }}
        >
            <If condition={title !== undefined}>
                <Grid
                    container
                    sx={{
                        justifyContent: 'space-between',
                        color: enabled ? 'text.primary' : 'text.secondary',
                    }}
                >
                    <Typography variant={'h2'} mb={2}>
                        {title}
                    </Typography>
                    {headerButton}
                </Grid>
            </If>
            {children}
        </Paper>
    );
};
